import React from "react";
import { RouterRecord } from "./routerInterfaces";

import DefaultLayout from "../../layouts/default/DefaultLayout";
import MainLayout from "../../layouts/main/MainLayout";
import BookmarkPage from "../../pages/bookmarkPage/bookmarkPage";
import DeveloperTools from "../../pages/developer/DeveloperTools";
import SearchPage from "../../pages/searchPage/SearchPage";

const LoginPage = React.lazy(() => import("../../pages/loginPage/LoginPage"));
const ProgramPage = React.lazy(() => import("../../pages/programPage/ProgramPage"));
const CategoryListPage = React.lazy(() => import("../../pages/categoryPages/categoryListPage/CategoryListPage"));
const CategoryDetailPage = React.lazy(() => import("../../pages/categoryPages/categoryDetailPage/CategoryDetailPage"));
const ArtistPage = React.lazy(() => import("../../pages/artistPage/ArtistPage"));
const ProfilePage = React.lazy(() => import("../../pages/profile/ProfilePage"));
const PreparationPage = React.lazy(() => import("../../pages/preparation/PreparationPage"));
const PlayerPage = React.lazy(() => import("../../pages/playerPage/PlayerPage"));
const LiveChannelPlayerPage = React.lazy(() => import("../../pages/liveChannelPlayerPage/LiveChannelPlayerPage"));
const ErrorPage = React.lazy(() => import("../../pages/error/error/ErrorPage"));
const LandingPage = React.lazy(() => import("../../pages/landingPage/LandingPage"));
const NotFoundPage = React.lazy(() => import("../../pages/error/notFound/NotFoundPage"));
const SubscriptionErrorPage = React.lazy(
  () => import("../../pages/subscriptionErrorPage/subscriptionPage/SubscriptionPage"),
);
const TicketErrorPage = React.lazy(() => import("../../pages/subscriptionErrorPage/ticketPage/TicketPage"));

const routes: RouterRecord[] = [
  {
    id: "MAIN_LAYOUT",
    layoutComponent: (props) => <MainLayout>{props.children}</MainLayout>,
    children: [
      {
        id: "PROGRAM_PAGE",
        path: "/p/:uid",
        element: <ProgramPage />,
      },
      {
        id: "DEVELOPER_TOOLS",
        path: "/dev",
        element: <DeveloperTools />,
      },
      {
        id: "CATEGORY_DETAILS",
        path: "/c/:descriptor",
        element: <CategoryDetailPage tagTypeId="3085b513-d011-4fb4-85c9-bee33d80f11e" />,
      },
      {
        id: "GENRE_DETAILS",
        path: "/g/:descriptor",
        element: <CategoryDetailPage tagTypeId="dd27af61-3cac-4b52-bfca-e282b7aedb0c" />,
      },
      {
        id: "TAG_DETAILS",
        path: "/t/:descriptor",
        element: <CategoryDetailPage tagTypeId="706179fc-25ca-415f-b068-b4aeb971f4e6" />,
      },
      {
        id: "CATEGORY_LIST",
        path: "/c",
        element: (
          <CategoryListPage
            isCategory={true}
            title="دسته بندی های فیلم و سریال"
            tagTypeId="3085b513-d011-4fb4-85c9-bee33d80f11e"
          />
        ),
      },
      {
        id: "GENRE_LIST",
        path: "/g",
        element: (
          <CategoryListPage
            isCategory={false}
            title="ژانرهای فیلم و سریال"
            tagTypeId="dd27af61-3cac-4b52-bfca-e282b7aedb0c"
          />
        ),
      },
      {
        id: "ARTIST_DETAILS",
        path: "/a/:descriptor",
        element: <ArtistPage />,
      },
      {
        id: "SEARCH_PAGE",
        path: "/search",
        exact: true,
        element: <SearchPage />,
      },
      {
        id: "LANDING_PAGE",
        path: "/",
        exact: true,
        element: <LandingPage />,
      },
      {
        id: "BOOKMARK_PAGE",
        path: "/watch-list",
        element: <BookmarkPage />,
        authRequired: true,
        authRedirectUrl: "/login",
        withRedirectUrl: false,
      },
    ],
  },
  {
    id: "DEFAULT_LAYOUT",
    layoutComponent: (props) => <DefaultLayout>{props.children}</DefaultLayout>,
    children: [
      {
        id: "LOGIN_PAGE",
        path: "/login",
        element: <LoginPage />,
        authRequired: false,
        authRedirectUrl: "/",
        withRedirectUrl: false,
      },
      {
        id: "SUBSCRIPTION_PAGE",
        path: "/subscription",
        element: <SubscriptionErrorPage />,
        authRequired: true,
        authRedirectUrl: "/",
        withRedirectUrl: false,
      },
      {
        id: "TICKET_PAGE",
        path: "/ticket/:uid",
        element: <TicketErrorPage />,
        authRequired: true,
        authRedirectUrl: "/",
        withRedirectUrl: false,
      },
      {
        id: "PROFILE",
        path: "/profile",
        element: <ProfilePage />,
        authRequired: true,
        authRedirectUrl: "/",
        withRedirectUrl: false,
      },
      {
        id: "PREPARATION",
        path: "/preparation/:t",
        element: <PreparationPage />,
      },
      {
        id: "EPISODE_PLAYER",
        path: "/w/:uid",
        element: <PlayerPage isTrailer={false} />,
        authRequired: true,
        authRedirectUrl: "/login",
        withRedirectUrl: true,
      },
      {
        id: "LIVE_CHANNEL_PLAYER",
        path: "/lc/:descriptor",
        element: <LiveChannelPlayerPage />,
        authRequired: true,
        authRedirectUrl: "/login",
        withRedirectUrl: true,
      },
      {
        id: "TRAILER_PLAYER",
        path: "/pr/:uid",
        element: <PlayerPage isTrailer={true} />,
      },
      {
        id: "ERROR_NOT_FOUND",
        path: "/error/404",
        element: <NotFoundPage />,
      },
      {
        id: "ERROR",
        path: "/error",
        element: <ErrorPage />,
      },
      {
        id: "NOT_FOUND",
        path: "/",
        element: <NotFoundPage />,
      },
    ],
  },
];

export default routes;
